import axios from 'axios';
import host from '../global';

export const getPublicJobsByOrganizationService = async (
  organizationId,
  page = 1,
  pageSize = 10,
  { postingDateFrom, search } = {},
) => {
  const response = await axios.get(`${host}/public/jobs`, {
    params: {
      organization_id: organizationId,
      page,
      page_size: pageSize,
      ...(postingDateFrom ? { posting_date_from: postingDateFrom } : {}),
      ...(search ? { search } : {}),
    },
  });
  return response.data;
};

export const getPublicJobLinkService = async (jobId) => {
  const response = await axios.get(`${host}/public/job-link/${jobId}`);
  return response.data;
};

export const getPublicOrganizationByIdService = async (organizationId) => {
  const response = await axios.get(`${host}/public/organization/${organizationId}`);
  return response.data;
};